export function setGalleries (state, galleries) {
    state.galleries = galleries;
  }
  
export function setGallery (state, gallery){
  state.selectedGallery = gallery
}

export function galleriesError(state, payload){
  state.error = true
  state.errorMessage = payload
  state.galleries = []
}
